"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var React = __importStar(require("react"));
var icons_1 = require("../../icons");
var material_1 = require("../../styles/material");
exports.Checkbox = function (_a) {
    var label = _a.label, checked = _a.checked, disabled = _a.disabled, onChange = _a.onChange, rest = __rest(_a, ["label", "checked", "disabled", "onChange"]);
    return (React.createElement(core_1.ThemeProvider, { theme: material_1.theme },
        React.createElement(core_1.FormControlLabel, __assign({ label: label, disabled: disabled, control: React.createElement(core_1.Checkbox, { icon: icons_1.Unchecked, checkedIcon: icons_1.Checked, checked: checked, onChange: function (event) {
                    if (!!onChange)
                        onChange(event.target.checked);
                } }) }, rest))));
};
//# sourceMappingURL=Checkbox.js.map